export type Bounds = { left: number; right: number; width: number };

/*                                                                                       */
export function fullyVisibleIndices(stage: Bounds, tiles: Map<number, Bounds>): number[] | undefined {
    if (stage.width === 0) return [...tiles.keys()];
    if ([...tiles.values()].some((tile) => tile.width === 0)) return undefined;

    /*                                                                           */
    return [...tiles]
        .filter(([, tile]) => tile.left > stage.left - 1 && tile.right < stage.right + 1)
        .map(([index]) => index);
}
